import "core-js/modules/es.array.concat.js";
import { axiosInstance } from '@applyboard/ui-utils';
var API = "/api/note_templates";
export var getNoteTemplates = function getNoteTemplates() {
  return axiosInstance.get("".concat(API, "/search"));
};
export var getNoteTemplateCategories = function getNoteTemplateCategories() {
  return axiosInstance.get("".concat(API, "/categories"));
};
export var getNoteTemplateVariables = function getNoteTemplateVariables() {
  return axiosInstance.get("".concat(API, "/variables"));
};
export var createNoteTemplate = function createNoteTemplate(title, description, noteTitle, text, category) {
  return axiosInstance.post(API, {
    title: title,
    description: description,
    note_title: noteTitle,
    text: text,
    category: category
  });
};
export var updateNoteTemplate = function updateNoteTemplate(id, title, description, noteTitle, text, category) {
  return axiosInstance.patch("".concat(API, "/").concat(id), {
    title: title,
    description: description,
    note_title: noteTitle,
    text: text,
    category: category
  });
};
export var deleteNoteTemplate = function deleteNoteTemplate(id) {
  return axiosInstance["delete"]("".concat(API, "/").concat(id));
};
export var renderNoteTemplate = function renderNoteTemplate(id, application_id) {
  return axiosInstance.get("".concat(API, "/").concat(id, "/populate?application_id=").concat(application_id));
};